
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"53.367","height":"50.044","viewBox":"0 0 56 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"checkmark","stroke":"#ffffff","stroke-width":"2","d":"M70.434-71.03a4.4,4.4,0,0,0-3.272,1.822C57.943-57.66,49.531-46.3,40.625-34.967L29.707-45.861a4.135,4.135,0,0,0-3.5-1.269,4.623,4.623,0,0,0-3.194,2.2,7,7,0,0,0,.744,8.365l14.28,14.277a4.089,4.089,0,0,0,6.337-.446C54.626-35.576,63.83-48.212,73.885-60.807a7.061,7.061,0,0,0,1.078-6.59c-.766-2.263-2.562-3.709-4.529-3.634Z","transform":"translate(-21.97 71.034)","fill":"#0aff00"}})])
          )
        }
      }
    